import { enqueueSnackbar } from "notistack";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  ICreateTagRequest,
  IUpdateTagRequest,
  TUpdateSettingsRequest,
} from "../../services/apiV2.types";
import { INTERNAL_SERVER_ERROR } from "../../constants";
import {
  createTag,
  deleteTag,
  getSettings,
  getTags,
  updateSettings,
  updateTag,
} from "../../services/apiV2";

export const getTagsThunk = createAsyncThunk(
  "settings/getTagsThunk",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getTags();
      return response.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  },
);

export const createTagThunk = createAsyncThunk(
  "settings/createTagThunk",
  async (req: ICreateTagRequest, { rejectWithValue }) => {
    try {
      const response = await createTag(req);
      return response.data;
    } catch (error) {
      console.error(error);
      enqueueSnackbar(INTERNAL_SERVER_ERROR, { variant: "error" });
      return rejectWithValue(error);
    }
  },
);

export const updateTagThunk = createAsyncThunk(
  "settings/updateTagThunk",
  async (req: IUpdateTagRequest, { rejectWithValue }) => {
    try {
      const response = await updateTag(req);
      return response.data;
    } catch (error) {
      console.error(error);
      enqueueSnackbar(INTERNAL_SERVER_ERROR, { variant: "error" });
      return rejectWithValue(error);
    }
  },
);

export const deleteTagThunk = createAsyncThunk(
  "settings/deleteTagThunk",
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await deleteTag(id);
      return response.data;
    } catch (error) {
      console.error(error);
      enqueueSnackbar(INTERNAL_SERVER_ERROR, { variant: "error" });
      return rejectWithValue(error);
    }
  },
);

export const getSettingsThunk = createAsyncThunk(
  "settings/getSettingsThunk",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getSettings();
      return response.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  },
);

export const updateGeneralSettingsThunk = createAsyncThunk(
  "settings/updateGeneralSettingsThunk",
  async (req: TUpdateSettingsRequest, { rejectWithValue }) => {
    try {
      const response = await updateSettings(req);
      return response.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  },
)

export const updateProductAnalyzerSettingsThunk = createAsyncThunk(
  "settings/updateProductAnalyzerSettingsThunk",
  async (req: TUpdateSettingsRequest, { rejectWithValue }) => {
    try {
      const response = await updateSettings(req);
      return response.data;
    } catch (error) {
      console.error(error);
      return rejectWithValue(error);
    }
  },
)
